/**
 * よくあるご質問のキーワード検索の当て方（docs/features/01 §7）。
 *
 * <b>表記の揺れをある程度吸収する。</b>問い合わせる人は「ＩＰアドレス」「ip アドレス」「サーバー」のように書く。
 *
 * - 全角と半角（英数字・記号・カタカナ）は NFKC で揃える
 * - 大文字と小文字は小文字に揃える
 * - ひらがなはカタカナに揃える（「ぷらん」でも「プラン」に当たる）
 * - 長音（ー）と空白は無いものとして比べる（「サーバ」「サーバー」「IP アドレス」「IPアドレス」）
 *
 * <b>空白で区切った言葉はすべて含むものだけ</b>を残す（「解約 データ」は両方を含む設問）。
 */

/** ひらがな（ぁ〜ゖ）をカタカナへ移す幅。 */
const kanaOffset = 0x60;

/** 比べるための形にする。 */
export function normalizeForSearch(text: string): string {
    let result = "";
    for (const character of text.normalize("NFKC").toLowerCase()) {
        const code = character.codePointAt(0) ?? 0;
        if (code >= 0x30_41 && code <= 0x30_96) {
            result += String.fromCodePoint(code + kanaOffset);
        } else if (character !== "ー" && !/\s/u.test(character)) {
            result += character;
        }
    }
    return result;
}

/** 入れた言葉を、比べる形の言葉の並びにする。<b>空なら空の並び</b>（絞らない）。 */
export const searchTerms = (query: string): string[] =>
    query.normalize("NFKC").split(/\s+/u).map((term) => normalizeForSearch(term)).filter((term) => term !== "");

/** 比べる形にした文字が、言葉をすべて含むか。 */
export const matchesTerms = (normalizedText: string, terms: readonly string[]): boolean =>
    terms.every((term) => normalizedText.includes(term));
